export default __webpack_public_path__ + "static/media/movetex.eefcb3d8.svg";